import { ModuleFE_ProviderChat } from './ModuleFE_ProviderChat.js';
export const ModulePack_ProviderChatDB = [ModuleFE_ProviderChat];
//# sourceMappingURL=module-pack.js.map